const GainAPEvent = function( battleState, potency ) {
	this.eventHandle = 'gain_ap';
	this.potency = potency;	

	this.execute = ( victim ) => {
		this.victimId = victim.uid;

		victim.ap += potency;

		this.affectedPieces = [ victim ]; 
		battleState.onBattleEvent( this );	
	};
};
module.exports = GainAPEvent
